import { useCallback } from "react"

export const useReloadPage = () => {

    return useCallback(() => {
        window.location.reload()
    }, [])
}
